



























import { Component, Vue, Ref } from 'vue-property-decorator';
import Order from '@/components/Invoicing/Order/Order.vue';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import {
  populateOrderWithUserNonChangeableSupplierInfo,
  populateOrderWithUserChangeableSupplierInfo,
  populateOurReference,
} from '@/app/Order';
import { newRecurringOrderObject, formatRecurringOrderDataForMutation } from '@/app/RecurringOrder';
import DeepCopy from '@/decorators/deep-copy';

import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_orderNewData_currentUser } from '@/queries/__generated__/orderNewData';
import { ORDER_NEW_DATA } from '@/queries/Order';

import RecurringOrderSettingForm from '@/components/Invoicing/RecurringOrder/RecurringOrderSettingForm.vue';
import RecurringOrderNewControls from '@/components/Invoicing/RecurringOrder/Controls/RecurringOrderNewControls.vue';
import { GQL_recurringOrderFragments } from '@/queries/__generated__/recurringOrderFragments';

import { CREATE_RECURRING_ORDER } from '@/queries/RecurringOrder';
import i18n from '@/i18n';

import unitInvoiceSettingsRequiredGuard from '@/guards/unit-invoice-settings-required-guard';
import checkSupplierMandatoryFieldsGuard from '@/guards/order-supplier-party-guard';

@Component({
  components: {
    Order,
    RecurringOrderNewControls,
    RecurringOrderSettingForm,
  },
  beforeRouteEnter(to, from, next) {
    checkSupplierMandatoryFieldsGuard().then(() => {
      unitInvoiceSettingsRequiredGuard(to, from, next);
    }).catch(router => {
      router.push({ name: 'RecurringOrders' });
      router.app.$sMessage.error(router.app.$t('Order.supplierPartyIsMissingInfo'), { duration: 0 });
    });
  },
})
export default class RecurringOrdersNew extends Vue {
  @SmartQuery<RecurringOrdersNew>({
    query: ORDER_NEW_DATA,
    fetchPolicy: "no-cache",
    result({ data }) {
      populateOrderWithUserNonChangeableSupplierInfo(this.formData.order, data.currentUser.currentUnit);
      populateOrderWithUserChangeableSupplierInfo(this.formData.order, data.currentUser.currentUnit);
      populateOurReference(this.formData.order.supplierParty, this.currentUser);
    },
  }) public currentUser!: GQL_orderNewData_currentUser;

  private formatData = formatRecurringOrderDataForMutation;

  public data: { order: GQL_recurringOrderFragments } = { order: newRecurringOrderObject() as GQL_recurringOrderFragments };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData: any = null;
  private validOrderForm = true;
  private validRecurringOrderSettingForm = true;

  @Ref() public readonly orderRef!: Order;

  @UnsavedChanges<RecurringOrdersNew>({
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) private dirtyForm = false;

  private saveAndContinue() {
    return this.$apollo.mutate({
      mutation: CREATE_RECURRING_ORDER,
      variables: this.formatData(this.formData),
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      return false;
    });
  }

  private resetFormDirty() {
    this.orderRef.formRef?.resetDirty();
  }
}
